import React from 'react'
import { Link } from 'react-router-dom'
import FormSF from '../../../widgets/form/FormSF'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import CreditAssessmentDateModalSF from './CreditAssessmentDateModalSF'

const BankStatementCollectionUI = ({ context, account,
  bsFileList, bankAccountList,
  onEnableReuploadClick, onDeleteAndReuploadClick,
  reuploadSubmitted, reuploadSuccessMsg, reuploadErrorList, reuploadType, reuploadEnabled,
  npFileList, onNPSubmit, npSubmitted, npSuccessMsg, npErrorList, setNPErrorList,
  updateDateMode, onUpdateDateClick, onCancelDateClick, onAccountUpdate,
  onDownloadFileClick, fileErrorList, onDeleteClick,
  bsUploadMode, onBSUploadClick, onBSCancelUploadClick, bsSignedUrlApi, onBSUpload, bsUploadErrorList,
  selectedFolder, onViewFolderClick,
  onClientTxnsReuploadClick, clientTxnsReuploadSubmitted,
  onDeleteTxnClick, deleteSubmitted
}) => {

  const newUploads =
    bsFileList && bsFileList['New Uploads']
      ? bsFileList['New Uploads']
      : []
  const latestDocId = account.documentStatus.creditAssessmentDocId
  const latestDocFolder =
    Object.keys(npFileList || {})
      .find(key =>
        key.startsWith(`${latestDocId}_`)
      )

  const newUploadNPFiles =
    npFileList && latestDocFolder
      ? (npFileList[latestDocFolder] || [])
      : []

  const npStatus = account.documentStatus.npCAStatus

  const folderSet = new Set([
    ...Object.keys(bsFileList || {}),
    ...Object.keys(npFileList || {})
  ])
  const getBankStatementFolderLabel = (label) => {

    label = label.trim()

    if (label === 'Legacy Files') {
      return label
    }

    const parts = label.split('_')

    if (parts.length !== 3) {
      return label
    }

    const [docId, startDate, endDate] = parts

    const formatMonthYear = (dateString) =>
      new Date(dateString).toLocaleDateString(
        'en-IN',
        {
          month: 'short',
          year: 'numeric'
        }
      )

    return `${docId}_${formatMonthYear(startDate)} - ${formatMonthYear(endDate)}`
  }

  const isLatestDocFolder = (label, latestDocId) =>
    label === latestDocId ||
    label.startsWith(`${latestDocId}_`)

  const historicalFolders =
    Array.from(folderSet)
      .filter(label => {

        if (label === 'New Uploads') {
          return false
        }

        const isLatestDoc =
          isLatestDocFolder(label, latestDocId)

        if (
          isLatestDoc &&
          npStatus === 'requested'
        ) {
          return false
        }

        return true

      })
      .sort((labelA, labelB) => {

        if (labelA === 'Legacy Files') return 1
        if (labelB === 'Legacy Files') return -1

        const aLatest =
          isLatestDocFolder(labelA, latestDocId)

        const bLatest =
          isLatestDocFolder(labelB, latestDocId)

        if (aLatest && !bLatest) return -1
        if (!aLatest && bLatest) return 1

        return 0
      })

  return (
    <div>
      <CardUI title='Bank statements collection' className='g_m_top_100'>
        <div className='g_flex_h g_flex_top'>
          <div className='g_flex_h'>
            <div>
              {
                (newUploads.length > 0 ||
                  npStatus && npStatus !== 'collected') &&
                <LRTableBodyUI className='g_m_top_25'>
                  <LRTableRowUI
                    context={context}
                    left={
                      <div className='g_flex_h g_flex_top'>
                        <span>
                          New Uploads ({newUploads.length + newUploadNPFiles.length} files)
                        </span>
                      </div>
                    }
                    right={null}
                  />
                  <LRTableRowUI
                    context={context}
                    className='g_flex_top'
                    left={
                      <div className='g_flex_v'>

                        <span className='g_muted'>
                          Bank Statements
                        </span>

                        {
                          newUploads.map(item => (
                            <span
                              key={item}
                              className='g_flex_h g_flex_left g_m_top_25'
                            >
                              <Link
                                className='g_m_right_50'
                                onClick={onDownloadFileClick}
                                to='#'
                                data-type='bs'
                                data-file-name={item}
                                data-folder='New Uploads'
                              >
                                {item}
                              </Link>

                              {
                                context.permissions.includes('su_manage') &&
                                <span
                                  className='icon icon-trash-o g_m_left_25 g_cursor_pointer g_muted'
                                  onClick={onDeleteClick}
                                  data-file-name={item}
                                  data-folder='New Uploads'
                                />
                              }
                            </span>
                          ))
                        }
                      </div>
                    }
                    right={
                      npStatus !== 'requested' &&
                      <FormSF
                        context={context}
                        buttonLabel='Share with Novel Patterns'
                        onSubmit={onNPSubmit}
                        busy={npSubmitted}
                        inlineButton={true}
                        successMsg={npSuccessMsg}
                        errorList={npErrorList}
                        setErrorList={setNPErrorList}
                      />
                    }
                  />
                  <LRTableRowUI
                    context={context}
                    className='g_flex_top'
                    left={
                      (npStatus !== 'collected') &&
                      <div className='g_flex_v'>
                        <span className='g_muted g_m_top_50'>
                          Novel Patterns
                        </span>

                        {
                          newUploadNPFiles.map(file => (
                            <Link
                              key={file}
                              className='g_m_top_25'
                              onClick={onDownloadFileClick}
                              to='#'
                              data-type='np'
                              data-file-name={file}
                              data-folder={latestDocFolder}
                            >
                              {file}
                            </Link>
                          ))
                        }

                        {
                          account.documentStatus.creditAssessmentDocId &&
                          <span className='g_m_top_25'>
                            Doc Id: {account.documentStatus.creditAssessmentDocId}
                          </span>
                        }
                      </div>
                    }
                    right={
                      npStatus !== 'collected' &&
                      <div className='g_flex_v g_text_right'>
                        <span>
                          <BadgeUI label={npStatus} />
                        </span>

                        <span className='g_muted'>
                          {account.documentStatus.npStatusDateF1}
                        </span>
                      </div>
                    }
                  />
                </LRTableBodyUI>
              }
              {
                historicalFolders.map((label) => {
                  const files =
                    bsFileList && bsFileList[label]
                      ? bsFileList[label]
                      : []

                  const npFiles =
                    npFileList && npFileList[label]
                      ? npFileList[label]
                      : []

                  const isLatestDoc = isLatestDocFolder(label, latestDocId)

                  return (

                    <LRTableBodyUI
                      key={label}
                      className='g_m_top_25'
                    >
                      <LRTableRowUI
                        context={context}
                        left={
                          <div
                            className='g_flex_h g_flex_top'
                            onClick={() => onViewFolderClick(label)}
                            style={{ cursor: 'pointer' }}
                          >
                            <span>
                              {selectedFolder === label ? '▼' : '▶'}{' '}
                              {getBankStatementFolderLabel(label)}
                              {' '}
                              ({files.length + npFiles.length} files)
                            </span>
                          </div>

                        }
                        right={null}
                      />
                      {
                        selectedFolder === label &&
                        <LRTableRowUI
                          context={context}
                          className='g_flex_top'
                          left={
                            <div className='g_flex_v'>

                              <span className='g_muted'>
                                Bank Statements
                              </span>

                              {
                                files.map(file =>
                                  <span
                                    key={file}
                                    className='g_flex_h g_flex_left g_m_top_25'
                                  >
                                    <Link
                                      className='g_m_right_50'
                                      onClick={onDownloadFileClick}
                                      to='#'
                                      data-type='bs'
                                      data-file-name={file}
                                      data-folder={label}
                                    >
                                      {file}
                                    </Link>
                                  </span>
                                )
                              }
                              {
                                (npFiles.length > 0 || (isLatestDoc && npStatus === 'collected'))
                                &&
                                <div className='g_flex_v'>
                                  <div className='g_flex_h g_flex_space_between g_flex_top g_m_top_50'>
                                    <span className='g_muted g_m_top_50'>
                                      Novel Patterns
                                    </span>

                                    {
                                      isLatestDoc && (
                                        <div className='g_flex_v g_text_right'>
                                          <span>
                                            <BadgeUI label={account.documentStatus.npCAStatus} />
                                          </span>
                                          <span className='g_muted'>
                                            {account.documentStatus.npStatusDateF1}
                                          </span>
                                        </div>
                                      )
                                    }
                                  </div>

                                  {
                                    npFiles.map(file => (
                                      <Link
                                        key={file}
                                        className='g_m_top_25'
                                        onClick={onDownloadFileClick}
                                        to='#'
                                        data-type='np'
                                        data-file-name={file}
                                        data-folder={label}
                                      >
                                        {file}
                                      </Link>
                                    ))
                                  }
                                </div>
                              }

                            </div>
                          }
                          right={null}
                        />
                      }
                    </LRTableBodyUI>

                  )
                })
              }
              {
                fileErrorList && fileErrorList.length > 0 &&
                <span>{fileErrorList[0].message}</span>
              }
            </div>
          </div>
          <div className='g_flex_v g_text_right'>
            <span><BadgeUI label={account.documentStatus.bankStatementReceiveStatus} /></span>
            {
              account.documentStatus.bankStatementReceiveStatus !== 'not_initiated' &&
              <>
                <span className='g_muted'>
                  {account.documentStatus.bankStatementStatusDateF1}<br />
                  {
                    bsFileList &&
                    Object.values(bsFileList)
                      .flat()
                      .length
                  } files
                </span>
              </>
            }
          </div>
        </div>
        <div className='g_flex_h g_flex_left g_m_top_50'>
          Credit assessment date
          <span className='g_muted g_m_left_50'>{account.documentStatus.creditAssessmentDateF1}</span>
          <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onUpdateDateClick} />
        </div>
        {
          account.documentStatus.npCAStatus === 'collected' &&
          <div className='g_flex_h g_flex_top g_m_top_25'>
            <span className='g_muted'>
              Novel Patterns Credit Assessment:
            </span>

            <Link
              className='g_m_left_50'
              to={`/su/accounts/${account.accountId}/scoreParams`}
              onClick={() => window.scrollTo(0, 0)}
            >
              View Score Params
            </Link>
          </div>
        }
        <CreditAssessmentDateModalSF context={context} account={account}
          updateMode={updateDateMode} onCancelClick={onCancelDateClick} onAccountUpdate={onAccountUpdate}
        />
        {
          (
            account.documentStatus.bankStatementReceiveStatus === 'collected' ||
            account.documentStatus.bankStatementReceiveStatus === 'skipped'
          ) &&
          !reuploadEnabled &&
          <div className='g_flex_h g_flex_top g_m_top_25'>
            <span className='g_muted'>
              If bank files need to be uploaded again, click the button:
            </span>
            <ButtonTinyWithSpinnerUI
              label='Enable Reupload'
              onClick={onEnableReuploadClick}
              alignLeft={false} errorList={reuploadErrorList}
              isLoading={reuploadSubmitted && reuploadType === 'enable'}
            />
          </div>
        }

        <div className='g_flex_h g_flex_top g_m_top_50'>
          <span className='g_muted'>Upload a pdf, or a zip file (without folders) containing bank statements:</span>
          <ButtonTinyWithSpinnerUI label='Upload Bank Statements' onClick={onBSUploadClick}
            alignLeft={false} errorList={bsUploadErrorList}
          />
        </div>

        {/* {
          account.documentStatus.bankStatementReceiveStatus === 'collected' &&
          <div className='g_flex_h g_flex_top g_m_top_50'>
            <span className='g_muted'>If borrower needs to re-upload bank statements again, click the button:</span>
            <FormSF context={context} buttonLabel='Delete All and Enable Re-upload'
              onSubmit={onDeleteAndReuploadClick} busy={reuploadSubmitted && reuploadType === 'delete'}
              successMsg={reuploadType === 'delete' ? reuploadSuccessMsg : null}
              errorList={reuploadType === 'delete' ? reuploadErrorList : []}
              inlineButton={true}
            />
          </div>
        } */}

        {
          context.permissions.includes('su_superuser_business') &&
          <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
            label='Delete Client Bank Transactions'
            onClick={onDeleteTxnClick} alignLeft={false}
            busy={deleteSubmitted}
          />
        }
        {
          context.permissions.includes('su_superuser_business') &&
          <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
            label='Reupload Client Txns from S3 to DB'
            onClick={onClientTxnsReuploadClick} alignLeft={false}
            busy={clientTxnsReuploadSubmitted}
          />
        }


        <FileUploadModalSF
          context={context}
          uploadMode={bsUploadMode}
          onCancelClick={onBSCancelUploadClick}
          signedUrlApi={bsSignedUrlApi}
          onUpload={onBSUpload}
        />
      </CardUI >

      <CardUI className='g_m_top_100' title='Bank account details'>
        <table className='g_small'>
          <thead>
            <tr>
              <th>S No.</th>
              <th className='g_p_left_100'>Account Number</th>
              <th className='g_p_left_100'>IFSC Code</th>
              <th className='g_p_left_100'>Bank Name</th>
              <th className='g_p_left_100'>Account Type</th>
              <th className='g_p_left_100'>Period Start</th>
              <th className='g_p_left_100'>Period End</th>
            </tr>
          </thead>
          <tbody>
            {
              bankAccountList && bankAccountList.map((bankAccount, i) =>
                <tr key={i}>
                  <td className='g_text_right'>{i + 1}</td>
                  <td className='g_p_left_100'>{bankAccount.bankAccountNumber}</td>
                  <td className='g_p_left_100'>{bankAccount.ifscCode}</td>
                  <td className='g_p_left_100'>{bankAccount.bankName}</td>
                  <td className='g_p_left_100'>{bankAccount.type}</td>
                  {
                    bankAccount.clientTxnPeriod &&
                    <>
                      <td className='g_p_left_100'>{bankAccount.clientTxnPeriod.periodStartDate}</td>
                      <td className='g_p_left_100'>{bankAccount.clientTxnPeriod.periodEndDate}</td>
                    </>
                  }
                </tr>
              )
            }
          </tbody>
        </table>
      </CardUI>
    </div >
  )
}
export default BankStatementCollectionUI
